import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/googleAnalytics';

// Hook to automatically track page views on route changes
export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const page_path = location.pathname + location.search;
    const page_title = document.title;
    
    trackPageView(page_path, page_title);
  }, [location]);
};

export default useGoogleAnalytics;
